import { Badge } from "react-bootstrap";
import { Cart, ChevronDown } from "react-bootstrap-icons";
import { IoBag } from "react-icons/io5";
import { CgMenuLeft } from "react-icons/cg";

import { useCart, useOrderOption, useStore } from "../../hooks";
import { useLayout } from "../../context";
import { transDate } from "../../helpers";
import { OrderType } from "../../enums";
import { Link, useLocation } from "react-router-dom";
import { SearchBar } from "./SearchBar/SearchBar";

type Props = {
  showCartIcon?: boolean;
};

const TopBar = ({ showCartIcon = true }: Props) => {
  const { cartQuantity } = useCart();
  const { orderOption } = useOrderOption();
  const { storeLocations } = useStore();
  const { pathname } = useLocation();

  const { toggleCart, setShowOptionModal, toggleSidebar } = useLayout();
  const isCheckoutPage =
    pathname === "/checkout" || pathname.startsWith("/checkout/");
  const isGiftcardPage =
    pathname === "/giftcard/purchase" ||
    pathname.startsWith("/giftcard/purchase/");

  return (
    <>
      {/* ================= MOBILE TOPBAR ================= */}
      <div
        style={{ zIndex: 9 }}
        className="menu-main-topbar col-md-12 position-sticky top-0 bg-white d-md-none justify-content-center align-items-center border-bottom mb-1 px-3 py-2 px-lg-4 py-lg-2"
      >
        <div className="col-md-7 col-sm-12 d-flex align-items-center gap-3 justify-content-between justify-content-md-start">
          <h3 className="menu_page_title d-none d-lg-block">Menu</h3>
          <span className="d-flex d-lg-none">
            <Link to={`/`}>
              <img height={50} src={storeLocations?.store_logo} alt="" />
            </Link>
          </span>
          <span className="d-flex flex-row align-items-center gap-2 d-md-none">
            {/* {!showCart && ( */}
            {showCartIcon && (
              <span className="d-flex flex-row pe-2">
                <span
                  className="cursor-pointer position-relative"
                  onClick={toggleCart}
                >
                  <Cart size={24} />
                  <Badge
                    pill
                    className="fw-light position-absolute mbcart-badge"
                    style={{ top: "-5px", right: "-10px" }}
                  >
                    {cartQuantity}
                  </Badge>
                </span>
              </span>
            )}
            {/* )} */}
          </span>{" "}
        </div>

        {/* <div className="col-md-5 col-sm-12 d-none d-md-flex justify-content-end align-items-center delivery-section">
          <div
            onClick={() => setShowOptionModal(true)}
            className="cursor-pointer card-content d-flex justify-content-between align-items-center col-md-5 col-sm-12"
          >
            <div className="content d-flex justify-content-start align-items-center">
              <IoBag className="icon-style" size={26} />
              <span className="card-option-subtitle">
                {orderOption.order_date ? (
                  <>
                    {transDate(orderOption.order_date)} at{" "}
                    {orderOption.order_time}
                  </>
                ) : (
                  "ASAP"
                )}
                <p className="mb-0 text-uppercase cart-option-title">
                  {orderOption.type_id == OrderType.DELIVERY && "Delivery"}
                  {orderOption.type_id == OrderType.PICKUP && "Pickup"}
                  {orderOption.type_id == OrderType.DINEIN && "Dine In"}
                </p>
              </span>
            </div>
            <ChevronDown className="right-icon-style" />
          </div>

          <div
            onClick={toggleCart}
            className="cursor-pointer card-content d-flex justify-content-between align-items-center col-md-3 col-sm-12"
          >
            <div className="content d-flex justify-content-center align-items-center position-relative">
              <span
                className="text-center"
                style={{ position: "relative", zIndex: 999 }}
              >
                {cartQuantity > 0 && (
                  <Badge
                    pill
                    text="dark"
                    className="fw-light position-absolute text-center cart-badge d-flex justify-content-center align-items-center pt-1"
                  >
                    {cartQuantity}
                  </Badge>
                )}
                <BsCartFill size={23} className="icon-style" />
              </span>
              <span className="cart-title"> Cart </span>
            </div>
          </div>
        </div> */}
      </div>

      <div className="home-desktop-topbar d-none d-md-flex">
        <div className="d-flex w-100">
          <button
            className="toggle-btn menu-toggle-btn d-flex justify-content-start align-items-center"
            onClick={toggleSidebar}
          >
            <CgMenuLeft />
          </button>
          <SearchBar />
        </div>

        {!isCheckoutPage && !isGiftcardPage && (
          <div className="home-header-actions">
            <button
              className="home-order-pill"
              type="button"
              onClick={() => setShowOptionModal(true)}
            >
              <IoBag size={20} />

              <span>
                <small>
                  {orderOption.order_date
                    ? `${transDate(orderOption.order_date)} ${orderOption.order_time}`
                    : "ASAP"}
                </small>

                <strong>
                  {orderOption.type_id == OrderType.DELIVERY && "Delivery"}
                  {orderOption.type_id == OrderType.PICKUP && "Pickup"}
                  {orderOption.type_id == OrderType.DINEIN && "Dine In"}
                </strong>
              </span>

              <ChevronDown size={16} />
            </button>

            <button
              className="home-cart-pill position-relative"
              onClick={toggleCart}
            >
              <Cart size={21} />

              {cartQuantity > 0 && (
                <Badge pill className="home-cart-badge">
                  {cartQuantity}
                </Badge>
              )}
            </button>

            {/* <div className="home-user-pill">
            <span className="home-user-avatar">
              {customer
                ? getNameInitials(
                    `${customer.first_name} ${customer.last_name}`,
                  )
                : "W"}
            </span>
            <span>Work</span>
            <ChevronDown size={16} />
          </div> */}
          </div>
        )}
      </div>
    </>
  );
};

export default TopBar;
